import { reactive, computed } from "vue";
import { useToday } from "./today";
import { useWeeks } from "./weeks";
import { useMonths } from "./months";

const state = reactive<{
  last_selected_id_today: string;
  last_selected_id_week: string;
  last_selected_id_month: string;
}>({
  last_selected_id_today: "today_0",
  last_selected_id_week: "week_0",
  last_selected_id_month: "month_0",
});

/**
 * Обновляет last_selected_id_* по префиксу применённого range id,
 * чтобы при следующем открытии модалки в блоке «Сегодня / Неделя / Месяц»
 * отображался тот же подпункт, что был применён.
 */
function syncLastFromRangeId(id: string) {
  if (id.startsWith("today")) state.last_selected_id_today = id;
  else if (id.startsWith("week")) state.last_selected_id_week = id;
  else if (id.startsWith("month")) state.last_selected_id_month = id;
}

/**
 * Глобальное (в рамках виджета Moneymap) состояние последних выбранных
 * подпунктов периода (Сегодня / Неделя / Месяц). Переживает закрытие модалки.
 * Текущий выбор периода и отображения графиков хранит модалка (из пропов).
 */
export function useMoneymapFilterLastSelected() {
  const today = useToday();
  const weeks = useWeeks();
  const months = useMonths();

  const last_today = computed(() => today.value.map[state.last_selected_id_today]);
  const last_week = computed(() => weeks.value.map[state.last_selected_id_week]);
  const last_month = computed(() => months.value.map[state.last_selected_id_month]);

  return {
    state,
    last_today,
    last_week,
    last_month,

    onTodayChange(id: string) {
      state.last_selected_id_today = id;
    },
    onWeekChange(id: string) {
      state.last_selected_id_week = id;
    },
    onMonthChange(id: string) {
      state.last_selected_id_month = id;
    },

    /** Вызвать при применении фильтра, чтобы запомнить last_* для следующего открытия. */
    syncLastFromAppliedRange(range_id: string) {
      syncLastFromRangeId(range_id);
    },
  };
}
